import React, {useMemo} from "react"
import {ErrorMessage} from "../ErrorMessage";
import {useParams} from "react-router-dom";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
import {Layout} from "../Layout";
import {useGetMassWarningTemplate} from "../hooks/useGetMassWarningTemplate";
import TemplateForm from "./TemplateForm";

export function TemplateEdit() {

    const {id} = useParams();
    const {data, isLoading, error} = useGetMassWarningTemplate(id);

    const content = useMemo(() => {
        if(data) return <TemplateForm template={data} mode={"edit"} />

        if(error) return <ErrorMessage text={"error loading template"} />

        if (isLoading) return <div className="flex justify-center p-8"><LoadingSpinner/></div>


    }, [
        data, isLoading, error
    ])



    return (
        <Layout menuCurrent={"templates"}>
                {content}
        </Layout>

    )


}

